import Vue from 'vue';

const resource = '/workorders';

export default {
  // CUSTOM ENDPOINT
  getWithWorkOrderItems(idPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `${resource}/${idPublic}?include=workorderitems`
    );
  },
};
